import { createFileRoute } from "@tanstack/react-router";
import { Overview } from "../../../features/console/overview";

export const Route = createFileRoute("/_authed/$org/$project/overview")({ component: OverviewPage });

function OverviewPage() {
  const { org, project } = Route.useParams();
  return <Overview org={org} project={project} />;
}
